import { render, staticRenderFns } from "./PSGModal.vue?vue&type=template&id=a401a896"
import script from "./PSGModal.vue?vue&type=script&lang=js"
export * from "./PSGModal.vue?vue&type=script&lang=js"
import style0 from "./PSGModal.vue?vue&type=style&index=0&id=a401a896&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports